const initialTermsCondition = `
<h3>1. Payment Terms:</h3>
<p>
  Our general payment terms is 40% advance along with Purchase order 
  and balance against final Proforma invoice prior to dispatch.
</p>
<p>&nbsp;</p>
<h3>2. Delivery Schedule:</h3>
<p>
  Delivery schedule in general will be considered 2–3 weeks from the date of purchase 
  order/receipt of advance payment whichever is later.
</p>
<p>&nbsp;</p>
<h3>3. Price Variation clause:</h3>
<p>
  The prices are based on the current rates and other levies on aluminium metal. 
  Any increase or decrease in the price of the aluminium metal and other inputs/levies 
  will be to buyers account. However, rates and other government levies like GST etc. 
  ruling on the date of dispatch shall be applicable irrespective of the delivery 
  period agreed/specified.
</p>
<p>&nbsp;</p>
<h3>4. Minimum order quantity:</h3>
<p>
  Minimum order quantity will be 300 kgs for each profile below 300 kgs the charges 
  will be applied as mentioned below:
</p>
<ul>
  <li>300–200 – 10 rupees / kgs</li>
  <li>200–100 – 20 rupees / kgs</li>
  <li>100–50 – 30 rupees / kgs</li>
  <li>Below 50 – Order quantity will not be accepted.</li>
</ul>
<p>&nbsp;</p>
<p>
  For first trial samples, there would not be any MOQ. Alux ERP will supply any desired 
  quantity by the customer at the agreed conversion cost.
</p>
<p>&nbsp;</p>
<h3>5. Tolerance:</h3>
<p>
  Weight tolerance of product – ±10% of specified drawing weight. Supply weight 
  tolerance if in kgs and above MOQ – ±10%, Supply weight tolerance if in kgs and 
  below MOQ – ±20%, Supply weight tolerance if in nos/pcs – ±15%.
</p>
<ul>
  <li>Supply weight tolerance if in Kgs and above moq –  +/- 10%</li>
  <li>Supply weight tolerance if in Kgs and below moq –  +/- 20%</li>
  <li>Supply weight tolerance if in nos/pcs  –  +/- 15%</li>
</ul>
<p>&nbsp;</p>
<h3>6. Length:</h3>
<p>Any specific length between 2000 mm to 6000 mm can be 
suppled without any extra charges any special length not falling 
between the above mentioned length will be charges as mentioned 
bellow. General cutting tolerance will be +/- 5 mm of specified 
length.
</p>
<p>&nbsp;</p>
<ul>
  <li>Between 1000 – 2000 mm – 1 rupees / kgs</li>
  <li>Above 6000 mm 5 rupees / kgs.</li>
</ul>
<p>&nbsp;</p>
<p>
Special cut to length products falling between 5 mm to 1000 mm 
shall be charged as per the product.
</p>
<p>&nbsp;</p>
<h3>7. Packing charges:</h3>
<p>&nbsp;</p>
<ul>
  <li>Strech film – 0.75 / kgs</li>
  <li>Strech + Hdpe – 1.5 / kgs</li>
  <li>Strech + Bubble + Hdpe – 2.5</li>
  <li>Strech + Interleaving + Hdpe – 3.5</li>
  <li>Corrugated box on request.</li>
  <li>Wooden Packing – on request.</li>
</ul>
<p>&nbsp;</p>
<h3>8. Interest:</h3>
<p>
  Interest will be applicable if the payment of the invoice is 
  not done within the agreed time / duration.  Interest will be 
  calculated @ 18% per annum.	
</p>
<p>&nbsp;</p>
<h3>9. Transit Insurance:</h3>
<p>
  ALux ERP will not be responsible for any transit damage unless it is 
  insured under our open policy.In such cases where the vehicle is 
  arranged by Alux ERP 0.25 rupees / kgs will be charged extra as 
  transit insurance. Vehicles arranged by customers shall not 
  be covered under our open policy, customers may arrange the 
  same from their end.
</p>
<p>&nbsp;</p>
<h3>10. Dispatch:</h3>
<p>
  Material to be lifted within 3 days after sharing the final 
  finished goods list / final profoma invoice if you fail to 
  lift the material within 3 days Alux ERP is liable to charge 
  interest @0.05% per day.
</p>
<p>&nbsp;</p>
<h3>11. Inspection & Rejection:</h3>
<p>
 Inspection, if any should be specified at time of placing the 
 purchase order and shall be carried out at our works only 
 prior to dispatch of the material. Our responsibility ceases 
 as soon as the material is handed over to the transporter.
 If any rejection is found it should be intimated in writing 
 immediately to Alux ERP or within 10 days from the date of 
 invoice. After the said time limit no complaint shall be 
 entertained.
</p>
<p>&nbsp;</p>
<h3>12. Change in order :</h3>
<p>
 Any alteration/cancellation in purchase order shall be 
 intimated before 10 days of dispatch. The buyer is liable 
 for all the losses incurred to the company due to the 
 alteration/cancellation in the purchase order.
</p>

`;

export default initialTermsCondition;
